import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import LinkButton from "../../utils/LinkButton";
import cursos from "../../static/images/cursos_default.png";

import useMediaQuery from "../../Hooks/useMediaQuery";

import user from "../../static/images/user_default.png";

function CarouselCursos({ id, qty }) {
  const [Courses, setCourses] = useState([]);
  const [indicators, setindicators] = useState([]);
  const [items, setitems] = useState([]);
  const isMobile = useMediaQuery("(max-width: 768px)");

  let history = useHistory();

  useEffect(() => {
    Carouselinner();
  }, []);

  function Carouselinner() {
    axios
      .get("company-course/all-courses/")
      .then((result) => {
        setCourses(result.data);
        LoadData(result.data);
      })
      .catch(function (error) {
        if (!error.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        } else if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else if (error.request) {
        }
      });
  }

  function LoadData(data) {
    let indice = 0;
    let step = 3;

    let arrItems = [];

    for (let index = 0; index <= data.length - 1; index) {
      let arr = data.slice(index, step);

      if (data != undefined) {
        let carItem = (
          <div
            key={Math.floor(Math.random() * 1000)}
            data-bs-interval="1000000"
            className={index == 0 ? "carousel-item active" : "carousel-item"}
          >
            {arr.map((item, index) => {
              return (
                <div key={item.courseId} className="card-item">
                  <div className="card-container text-center">
                    <div className="card-logo border-gray">
                      <img
                        loading="lazy"
                        src={item.fotoCurso != null ? item.fotoCurso : cursos}
                      ></img>
                    </div>
                    <p className="sub-title">{item.empresa}</p>
                    <p className="title">{item.name}</p>
                    <hr></hr>
                    <button
                      className="btn-deg"
                      onClick={() => {
                        setLink(item.courseId);
                      }}
                    >
                      Ver
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        );
        if (step + parseInt(qty) <= data.length) {
          index = step + 1;
          step += parseInt(qty) + 1;
        } else {
          index = step + 1;
          step = data.length;
        }
        indice++;
        arrItems.push(carItem);
      }
    }
    setitems(arrItems);
    LoadIndicators(indice);
  }

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={"" + index + ""}
          aria-label={"Slide " + (index + 1)}
          className={index == 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  function setLink(item) {
    let rol = localStorage.getItem("rol");
    let path;
    let state;

    switch (rol) {
      case "applicant":
        history.push({
          pathname: "/user/DetalleCurso/" + item,
          state: { courseId: item },
        });
        break;
      case "company":
        history.push({
          pathname: "/company/DetalleCurso",
          state: { courseId: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/DetalleCurso",
          state: { courseId: item },
        });
        break;
    }
  }
  /*      <div className="carousel-indicators">{indicators}</div>*/

  return (
    <div id={"carousel" + id} className="carousel slide" data-interval="false">
      <div className="carousel-inner">{items}</div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target={"#carousel" + id}
        data-bs-slide="prev"
      ></button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target={"#carousel" + id}
        data-bs-slide="next"
      ></button>
    </div>
  );
}

export default CarouselCursos;
